import { useState, useCallback } from 'react';
import { generateBaseThumbnail, removeBackground } from '../utils/replicateApi';

export const useReplicate = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(null);

  const generateThumbnail = useCallback(async (imageUrl, customTitle, additionalPrompt) => {
    try {
      setLoading(true);
      setError(null);
      setProgress('Starting generation...');
      
      const result = await generateBaseThumbnail(imageUrl, customTitle, additionalPrompt);
      
      setProgress(null);
      setLoading(false);
      
      return result;
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setProgress(null);
      throw err;
    }
  }, []);

  const removeBg = useCallback(async (imageUrl) => {
    try {
      setLoading(true);
      setError(null);
      setProgress('Starting background removal...');
      
      const result = await removeBackground(imageUrl);
      
      setProgress(null);
      setLoading(false);
      
      return result;
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setProgress(null);
      throw err;
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    loading,
    error,
    progress,
    generateThumbnail,
    removeBg,
    clearError,
  };
};
